import { preventPropagation } from 'src/CrudManager/Core/Utils/clickUtils'
import { showErrorNotification, showSuccessNotification } from 'src/CrudManager/Core/Utils/ToastNotification'
import type { Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { InfoBoxProps } from '../types'

export function useInfoBoxLogic(props: InfoBoxProps, copied: Ref<boolean>, isClipboardSupported: Ref<boolean>, cExpanded: Ref<boolean>) {
  const { t } = useI18n()

  const stripHtml = (html: string): string => {
    const tmp = document.createElement('div')
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ''
  }

  const copyToClipboard = async (e: Event) => {
    preventPropagation(e)
    if (!isClipboardSupported.value) {
      showErrorNotification(t('copy.notifications.unsupported'))
      return
    }

    try {
      const textToCopy = props.html ? stripHtml(props.copyValue || props.text || '') : props.copyValue || props.text || ''
      await navigator.clipboard.writeText(textToCopy)
      copied.value = true
      showSuccessNotification(t('copy.notifications.success'))
      setTimeout(() => {
        copied.value = false
      }, props.notifyDuration)
    } catch (err) {
      console.error('Failed to copy text: ', err)
      showErrorNotification(t('copy.notifications.error'), err)
    }
  }

  const handleToggleExpand = (event: Event) => {
    event.preventDefault()
    cExpanded.value = !cExpanded.value
  }

  const triggerIfExpanded = (e: Event) => {
    if (props.expandable) {
      handleToggleExpand(e)
    }
  }

  return {
    copyToClipboard,
    handleToggleExpand,
    triggerIfExpanded,
  }
}
